import { useQueryClient } from 'react-query';

import {
  cateringLeadsApiKeys,
  useCateringLeadsApi,
} from '../../../../hooks/api/catering-leads/useCateringLeadsApi';
import { useSearchApi } from '../../../../hooks/api/useSearchApi';
import type { SearchApiOptions } from '../../../../types/api';
import type {
  CateringLeadSearchFacetFields,
  CateringLeadSearchItem,
  CateringLeadSearchParams,
  CateringLeadSearchResults,
} from '../../../../types/events/catering-leads';

export function useSearchCateringLeads(
  organizationId: string,
  params: Partial<CateringLeadSearchParams>,
  {
    enabled = true,
    ...options
  }: Omit<
    Partial<
      SearchApiOptions<
        CateringLeadSearchItem,
        CateringLeadSearchFacetFields,
        CateringLeadSearchResults
      >
    >,
    'page' | 'queryKey' | 'request'
  > = {}
) {
  const queryClient = useQueryClient();
  const api = useCateringLeadsApi();
  const result = useSearchApi<
    CateringLeadSearchItem,
    CateringLeadSearchFacetFields,
    CateringLeadSearchResults
  >({
    enabled: !!organizationId && enabled,
    queryKey: cateringLeadsApiKeys.search(organizationId, params),
    request: () => api.search(organizationId, params),
    ...options,
  });
  return {
    ...result,
    invalidate: () =>
      queryClient.invalidateQueries(
        cateringLeadsApiKeys.search(organizationId, params)
      ),
  };
}
